(function() {
  'use strict';

  angular
    .module('scorm.scormCtrl')
    .factory('scormService', scormService);

  scormService.$inject = ['$http', 'ServiceHelper'];

  function scormService($http, ServiceHelper) {
    var url = {
      scorm: 'https://:host/:ipad/gaviota-api/trainee/cModule/:cModuleId/course/:courseId/frame/:frameId/sco'
    };
    var keys = ['ipad', 'cModuleId', 'frameId', 'courseId'];
    var service = {
      saveScoProperties: saveScoProperties
    };

    return service;

    function saveScoProperties(params, resultCb, errorCb) {
      var urlParams = _.extend(ServiceHelper.defaultUrlParams(), {
        courseId: params.courseId,
        cModuleId: params.cModuleId,
        frameId: params.frameId
      });

      return ServiceHelper.checkCanCallService(function() {
        return respond($http.post(createUrl(url.scorm, urlParams), {
          scoProperties: params.scoProperties,
          quiz: params.quiz,
          scormType: params.scormType
        }), resultCb, errorCb);
      });
    }

    function createUrl(baseUrl, data) {
      return keys.reduce(function(url, key) {
        return url.replace(new RegExp('/:' + key), '');
      }, Object.keys(data).reduce(function(url, key) {
        var value = data[key];
        return url.replace(new RegExp('/:' + key), value ? '/' + data[key] : '');
      }, baseUrl));
    }

    function respond(promise, resultCb, errorCb) {
      return promise.then(function(response) {
        resultCb = resultCb || angular.noop;
        return resultCb(response.data);
      }, function(response) {
        return ServiceHelper.errorHandler(errorCb || angular.noop)(response);
      });
    }
  }
})();
